import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import withAttr from 'flarum/common/utils/withAttr';
export default class BanUserModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "until", void 0);
    _defineProperty(this, "attrs", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.until = null;
    let until = this.attrs.user.attribute('shadowBannedUntil');

    // In case the database column ends up as 0000-00-00 00:00:00, the Carbon output will have a minus sign in front
    // We need to ignore this value because DayJS can't handle it
    if (typeof until === 'string' && until && until[0] === '-') {
      until = null;
    }
    if (until) {
      // If date is in the past behave the same way as if the user wasn't shadow banned
      if (new Date() > new Date(until)) until = null;
    }
    if (until) {
      // @ts-ignore dayjs type-hints not available
      this.until = dayjs(until).format('YYYY-MM-DDTHH:mm');
    }
  }
  className() {
    return 'ShadowBanUserModal Modal--small';
  }
  title() {
    return app.translator.trans('clarkwinkelmann-shadow-ban.forum.banUser.title', {
      user: this.attrs.user
    });
  }
  content() {
    return m('.Modal-body', m('.Form', [m('.Form-group', [m('label', app.translator.trans('clarkwinkelmann-shadow-ban.forum.banUser.until')), m('input.FormControl', {
      type: 'datetime-local',
      value: this.until || '',
      onchange: withAttr('value', value => {
        this.until = value || null;
      })
    })]), m('.Form-group', [m('label', app.translator.trans('clarkwinkelmann-shadow-ban.forum.banUser.quick')), Button.component({
      className: 'Button' + (this.until ? '' : ' active'),
      onclick: () => {
        this.until = null;
      }
    }, app.translator.trans('clarkwinkelmann-shadow-ban.forum.banUser.quickChoiceReset')), [1, 2, 7, 30].map(days => {
      let active = false;
      if (this.until) {
        // @ts-ignore
        const untilDayjs = dayjs(this.until);
        // @ts-ignore
        const from = dayjs().add(days, 'days').subtract(12, 'hours');
        // @ts-ignore
        const to = dayjs().add(days, 'days').add(12, 'hours');
        active = untilDayjs.isAfter(from) && untilDayjs.isBefore(to);
      }
      return Button.component({
        className: 'Button' + (active ? ' active' : ''),
        onclick: () => {
          // @ts-ignore dayjs type-hints not available
          this.until = dayjs().add(days, 'days').format('YYYY-MM-DDTHH:mm');
        }
      }, app.translator.trans('clarkwinkelmann-shadow-ban.forum.banUser.quickChoiceDays', {
        count: days
      }));
    })]), m('.Form-group', Button.component({
      className: 'Button Button--primary',
      loading: this.loading,
      type: 'submit'
    }, app.translator.trans('clarkwinkelmann-shadow-ban.forum.banUser.submit')))]));
  }
  onsubmit(event) {
    event.preventDefault();
    this.loading = true;
    this.attrs.user.save({
      // @ts-ignore dayjs type-hints not available
      shadowBannedUntil: this.until ? dayjs(this.until).toISOString() : null
    }).then(() => this.hide(), this.loaded.bind(this));
  }
}
flarum.reg.add('clarkwinkelmann-shadow-ban', 'forum/components/BanUserModal', BanUserModal);